import { pageMetadataSchema } from '../../../schema/pageMetadata.val';
import { s, nextAppRouter, c } from '../../../val.config';

const formSuccessSchema = s.object({
  header: s.string(),
  text: s.string(),
});

const formErrorSchema = s.object({
  header: s.string(),
  text: s.string(),
  mail: s.string(),
});

export const schema = s.object({
  title: s.string(),
  description: s.string(),
  email: s.string(),
  phone: s.string(),
  placeholders: s.object({
    email: s.string(),
    telephone: s.string(),
    message: s.string(),
  }),
  formSuccess: formSuccessSchema,
  formError: formErrorSchema,
  pageMetadata: pageMetadataSchema,
});

export default c.define(
  '/app/(main)/prosjektprat/page.val.ts',
  s.router(nextAppRouter, schema),
  {
    '/prosjektprat': {
      title: `Kontakt`,
      description: 'Fortell oss hva du har på hjertet, så hører du fra oss.',
      email: `hei@blank.no`,
      phone: `22204000`,
      placeholders: {
        email: '',
        telephone: '',
        message: '',
      },
      formSuccess: {
        header: `Takk takk!`,
        text: `Gi oss litt tid til å se over infoen din, så tar vi kontakt!`,
      },

      formError: {
        header: `Noe gikk galt med innsendingen :/`,
        text: `Din melding gikk dessverre ikke gjennom. Vi ønsker fortsatt å høre fra deg, så gjerne send oss en e-post på`,
        mail: `jaj@blank.no`,
      },

      pageMetadata: {
        title: `Bli kontaktet`,
        description: `Trenger du hjelp med design eller utvikling? Fyll ut skjemaet, vi hjelper deg gjerne!`,
        image: null,
      },
    },
  }
);
